( function () {
   
    'use strict';

    ( function ( $ ) {
               
        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.slider-nav',
        });
        $('.slider-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: false,
            focusOnSelect: true,
        });
        $('.product-count-add-cart button').click(function(e){
            var button_classes, value = +$('.counter1').val();
            button_classes = $(e.currentTarget).prop('class');        
            if(button_classes.indexOf('up_count') !== -1){
                value = (value) + 1;            
            } else {
                value = (value) - 1;            
            }
            value = value < 0 ? 0 : value;
            $('.counter1').val(value);
        });  
        $('.counter1').click(function(){
            $(this).focus().select();
        });
        $('.product-count-add-cart a.add-basket').click(function(){
            $(".product-left-slider-right-content").addClass('active');
        });
    } )( jQuery );
} )();

